import React, { createElement } from 'react'
import {
  RadioGroup,
  Radio,
  Stack,
  forwardRef,
} from "@chakra-ui/react"
import { useController } from 'react-hook-form'
import usePrettyOptions from '../../hooks/usePrettyOptions'

const TheRadioGroup = forwardRef(({ children = [], rules, ...props }, ref) => {
  const prettyOptions = usePrettyOptions(children)
  return (
    <RadioGroup colorScheme="primary" {...props} ref={ref}>
      <Stack direction="row" spacing={4}>
        {prettyOptions.map(({ value, label }, i) => <Radio value={value} key={i}>{label}</Radio>)}
      </Stack>
    </RadioGroup>
  )
})

const ContorlledRadioGroup = forwardRef(({ control, name, ...props }, ref) => {
  const { field } = useController({ control, name })
  return <TheRadioGroup {...props} ref={ref} {...field}  />
})

const RadioInput = forwardRef((props, ref) => {
  return createElement(props.control ? ContorlledRadioGroup : TheRadioGroup, {
    ...props,
    ref,
  })
})

RadioInput.displayName = 'RadioInput'

export default RadioInput
